export default {
	//对象
	state: {
		price: 2,
		products: [{
				name: '鼠标',
				price: 20
			},
			{
				name: '键盘',
				price: 40
			},
			{
				name: '耳机',
				price: 60
			},
			{
				name: '显示屏',
				price: 80
			}
		]
	},
	//操作对象 相当于JAVA中的set方法 绝对不允许出现异步
	mutations: {
		changePrice(state, payload) {
			console.log("changePrice",payload)
			state.price = payload;
		},
		minusPrice(state, payload) {
			state.products.forEach(product => {
				if(product.price > 0) {
					product.price -= payload
				}
			})
		}
	},
	//提交的是mutations而不是直接变更状态，相当于直接操作了一次mutations，不同的是可以异步
	actions: {
		minusPriceAsync(context, payload) {
			setTimeout(() => {
				context.commit('minusPrice', payload); //context提交
			}, 1000)
		}
	},
	//store的计算属性，理解为所有组件的computed属性，返回值会根据它的依赖被缓存起来，且只有当它的依赖值发生了改变才会被重新计算。
	getters: {
		saleProducts: (state) => {
			let saleProducts = state.products.map(product => {
				return {
					name: product.name,
					price: product.price / 2
				}
			})
			return saleProducts;
		}
	}
};


// WEBPACK FOOTER //
// ./src/vuex/demo.js